// JavaScript Document

jQuery(function($){
$('a[rel=tooltip]').popover();
});



//////////////////
// WEBPACK FOOTER
// ./source/javascripts/autologin_tip.js
// module id = 1139
// module chunks = 165